/***
**Module Name: loginotp
 **File Name :  loginotp.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains login otp validation page details.
 ***/
import React, { useState, useEffect, useRef, useContext } from "react";
import tmdbApi from "../api/tmdbApi";
import { useNavigate } from "react-router";
// import "../../src/assets/css/style.css"
import * as Config from "../constants/Config";
import OTPInput from "otp-input-react";

import Footer from "../components/footer/Footer";
import $ from 'jquery';
import { contentContext } from "../context/contentContext";


const SignInOtp = () => {
  const navigate = useNavigate();
  const [mpin, setInput] = useState({});
  const [otp, setOtp] = useState('');
  // const [menus, setMenus] = useState([]);
  const [error, setError] = useState([]);
  const [config, setConfig] = useState({});

  const [activeLoad, setActiveLoad] = useState("");
  const [resendActive, setResendActive] = useState(false);
  const [otpclass, setOtpClass] = useState(false);
  const one = useRef();
  const two = useRef();
  const three = useRef();
  const four = useRef();
  const five = useRef();
  const [locData, setLocData] = useState("");
  useEffect(() => {
    // appMenus();
    setLocData(JSON.parse(localStorage.getItem("loc")));
  }, []);
  const { menus, GetClientDataFunction } = useContext(contentContext);
  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigate("/content");
    }
    if (window.site) {
      setConfig(window.site);

    }
    if (localStorage.getItem("email") == null || localStorage.getItem("email") == "null") {
      navigate('/login')
    }

  }, [window.site]);

  if (config.common && config.common.imagesCDN) {
    var img = config.common.imagesCDN;
  }


  useEffect(() => {
    document
      .querySelectorAll('.signin-otp-input')
      .forEach((el, idx) => el.setAttribute('id', `signin-otp-${idx + 1}`));
  }, []);
  function handleClose() {
    navigate("/");
  }
  function handleEmailLogin() {
    navigate("/login")
  }

  const handleLogin = (e) => {

    console.log("otp", otp);
    if (otp === "" || otp === null) {
      setError("Please Enter Otp");
      setTimeout(function () { setError("") }, 3000);
      setActiveLoad("")
    } else {
      console.log("signOtp");
      if (activeLoad == "") {
        signOtp();
      }
    }
    localStorage.removeItem("loginuser");

  }
  const signOtp = async () => {

    try {
      setActiveLoad("loginOtp")
      const response = await tmdbApi.signOtp({
        "emailid": localStorage.getItem("email"),
        "logintype": "otp",
        "otp": Number(otp),
        "useragent": locData?.headers !== undefined ? locData?.headers : {}
      });
      console.log(response);
      if (response.result.res === "password not set") {
        localStorage.setItem("clientid", response.result.clientid);
        navigate("/generatepassword/?id=" + response.result.clientid);
      } else if (localStorage.getItem("check") && response.statusCode === 200) {
        console.log("came");
        localStorage.setItem("token", response.result.token);
        localStorage.setItem("clientid", response.result.clientid);
        localStorage.setItem("login", "setlogin");
        let currentDate = new Date().toJSON();
        localStorage.setItem("currentSessionClientTime", currentDate);
        GetClientDataFunction();
        navigate("/moreinfo/" + localStorage.getItem("check"));
      } else if (response.result.token) {
        console.log("came");
        localStorage.setItem("token", response.result.token);
        localStorage.setItem("clientid", response.result.clientid);
        let currentDate = new Date().toJSON();
        localStorage.setItem("currentSessionClientTime", currentDate);
        navigate("/content");
      } else {
        // setError(response.result);
        // setTimeout(function () { setError("") }, 3000);
        // var element = document.getElementById("otp");
        // element.classList.add("invalid");
        // setTimeout(function () { 
        // element.classList.remove("invalid");
        // setOtp("")
        // one.current.value="";
        // two.current.value="";
        // three.current.value="";
        // four.current.value="";
        // five.current.value="";
        //  }, 3000);
        setOtpClass(true)
        setActiveLoad("")
      }
    } catch {
      setActiveLoad("")
      console.log("error");
      // var element = document.getElementById("otp");
      // element.classList.add("invalid");

      //   setTimeout(function () { 
      //     element.classList.remove("invalid");
      //   setOtp("")
      // }, 3000);
    }
  };

  const handleResendOtp = async () => {
    setResendActive(true)
    setTimeout(function () {
      setResendActive(false)
    }, 3000)
    // setOtpClass(true)
    try {
      console.log(tmdbApi);
      const response = await tmdbApi.resendMail({
        "emailid": localStorage.getItem("email"),
        "type": "signin"
      });
      // setResendActive(false)
      console.log(response);
    } catch {
      setResendActive(false)

      console.log("error");
    }
  };

  const handleChange = (otp) => {
    setOtpClass(false);
    setOtp(otp)
  };
  const handleOtpError = (e) => {
    console.log("came");
    // var element = document.getElementById("otp");
    // element.classList.remove("invalid");
    setOtpClass(false)
  }

  const cardWidth = $(".signin-graphic").width();


  function handleClose() {
    localStorage.removeItem("formatsClick");
    navigate("/");
  }
  return (
    <>
      <div className="header-wrapper">

        <a className="navbar-brand" href="#">
          <img src={`${img}orasi/client/resources/orasiv1/images/logo_white.png`} alt="Logo" onClick={handleClose} />

        </a>

        {/* <p id="signin-prompt" className="signup-prompt">
          Already have an Account
          <a id="signin-link" href="/login" className="mx-2">Sign In</a>
        </p> */}

      </div>
      {/* <button id="signin-close-btn" className="close-btn" onClick={handleClose}>
    <span className="material-icons">close</span>
  </button> */}
      <div className="sign-in-bg"></div>
      <div className="otp-wrapper">
        <div id="signin-wrapper" className="signin-wrapper">
          <a id="signin-logo-link" href="/">
            <img
              id="signin-logo"
              src={img + "orasi/client/resources/orasiv1/images/logoupdated.png?auto=compress,format"}
              className="logo"
            />
          </a>

          <div id="signin-body" className="signin-body">

            <div id="signin-section" className="signin-section emaillogin">
              <h1 id="signin-heading" className="bold-heading">Login</h1>

              <p id="signin-otp-instructions">Enter 5 Digit OTP sent to your Email</p>
              <p id="signin-email-display">{localStorage.getItem("email")}</p>

              <div id="signin-otp-blocks" className="otp-blocks mt-5 mb-5">
                <div
                  id="signin-otp-inputs"
                  className={otpclass ? "otp-inputs block-margin invalid errorStyle" : "otp-inputs block-margin"}
                >
                  {/* <OTPInput
              id="signin-otp"
              value={otp}
              onChange={handleChange}
              autoFocus
              OTPLength={5}
              otpType="number"
              onFocus={(e) => handleOtpError(e)}
            /> */}

                  <OTPInput
                    value={otp}
                    onChange={handleChange}
                    autoFocus
                    OTPLength={5}
                    otpType="number"
                    onFocus={(e) => handleOtpError(e)}
                    inputClassName="signin-otp-input"
                    inputProps={{
                      "data-testid": "signin-otp-input"
                    }}
                  />




                  <p id="signin-otp-error-msg">The OTP you have entered is incorrect. Please try again or request a new OTP</p>
                </div>

                <button id="resend-otp-btn" className="resend-button" onClick={handleResendOtp}>
                  Resend
                </button>
                {resendActive ? (
                  <p
                    id="resend-otp-success"
                    style={{ fontSize: "12px", color: "green", position: "absolute", left: "0", bottom: "-29%" }}
                  >
                    OTP Resent!
                  </p>
                ) : null}
              </div>

              <div id="signin-footer" className="signin-footer mt-4">
                <button id="signin-login-btn" className="fill_btn yellow-gradient" onClick={e => handleLogin(e)}>
                  {activeLoad === "loginOtp" ? (
                    <img
                      id="signin-login-loader"
                      src={img + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"}
                      className="loading-icon"
                    />
                  ) : null}
                  LOGIN
                </button>

                <button id="signin-pwd-btn" className="sm-btn lgn-otp-btn" onClick={handleEmailLogin}>
                  Login with Password
                </button>
              </div>

              {error ? (
                <span
                  id="signin-error-msg"
                  className="errormsg"
                  style={{ fontWeight: "bold", color: "red" }}
                >
                  {error}
                </span>
              ) : ""}
            </div>
          </div>
        </div>
      </div>

      <Footer id="signin-footer-component" menus={menus} />
    </>

  );
};

export default SignInOtp;
